import React from 'react';

import { Trans } from 'react-i18next';
import colours from '../../../../../../Common/DesignSystem/Colours';
import Icon from '../../../../../../Common/DesignSystem/Icons/Icon';

import VehicleOverviewTab from './VehicleOverviewTab';
import VehicleBookingsTab from './VehicleBookingsTab';
import VehicleRemindersTab from './VehicleRemindersTab';
import VehicleSpecsTab from './VehicleSpecsTab';
import VehicleMediaTab from './VehicleMediaTab';
import VehicleRideReportsTab from './VehicleConditionReportsTab';
import VehicleExpensesTab from './VehicleExpensesTab';


const VehicleDetailsSelectedTab = ({ currentTab, vehicle, props, setTab, reports, bookings, vehicle_oem_details, vehicle_options, legacyApiVehicleData, placeholderImage, editVehicle }) => {
	const vehicleDetailsTabs = {
		'Overview': <VehicleOverviewTab {...props} vehicle={vehicle} vehicle_details={legacyApiVehicleData} setTab={setTab} reports={reports} />,
		'Bookings': <VehicleBookingsTab {...props} vehicle={vehicle} bookings={bookings} vehicle_details={legacyApiVehicleData} />,
		'Reminders': <VehicleRemindersTab {...props} vehicle={vehicle} vehicle_details={legacyApiVehicleData} />,
		'Specifications': <VehicleSpecsTab {...props} vehicle={vehicle} placeholderImage={placeholderImage} editVehicle={editVehicle} vehicle_details={legacyApiVehicleData} vehicle_oem_details={vehicle_oem_details} vehicle_options={vehicle_options} />,
		'Media': <VehicleMediaTab {...props} vehicle={vehicle} vehicle_details={legacyApiVehicleData} key={"mediatab_" + legacyApiVehicleData.media.outstanding.length + "_" + legacyApiVehicleData.media.complete.length + "_" + legacyApiVehicleData.media.dismissed.length}/>,
		'RideReports': <VehicleRideReportsTab {...props} vehicle={vehicle} vehicle_details={legacyApiVehicleData} reports={reports} />,
		'Expenses': <VehicleExpensesTab {...props} vehicle={vehicle} vehicle_details={legacyApiVehicleData} />
	}

	return vehicleDetailsTabs[currentTab];
}

export const VehicleDetailsTabs = ({ currentTab, vehicle, props, setTab, reports, bookings, vehicle_oem_details, vehicle_options, legacyApiVehicleData, placeholderImage, editVehicle }) => {
	const tabs = [
		{ tab: 'Overview', icon: 'Overview', shouldShow: true },
		{ tab: 'Bookings', icon: 'Booking', shouldShow: true },
		{ tab: 'Reminders', icon: 'Reminder', shouldShow: true },
		{ tab: 'Specifications', icon: 'Specsheet', shouldShow: true },
		{ tab: 'Media', icon: 'Media', shouldShow: legacyApiVehicleData.vehicle.has_media_components },
		{ tab: 'RideReports', icon: 'RideReport', shouldShow: true },
		{ tab: 'Expenses', icon: 'Expenses', shouldShow: true }
	];

	return (
		<>
			<div className="overlay_tabs">
				{tabs.map(({ shouldShow, tab, icon }) => shouldShow && (
					<div key={tab} className={"overlay_tab_option" + (currentTab === tab ? " overlay_tab_active" : "")} onClick={() => setTab(tab)}>
						<Icon name={icon} size={24} style={{color: currentTab === tab ? colours.primary.blue : colours.primary.grey02, marginRight: 4}}/>
						<Trans>{tab}</Trans>
					</div>
				))}
			</div>

			<VehicleDetailsSelectedTab {...{ currentTab, vehicle, props, setTab, reports, bookings, vehicle_oem_details, vehicle_options, legacyApiVehicleData, placeholderImage, editVehicle }} />
		</>
	)
}